module.exports = __webpack_public_path__ + "static/media/360south-logo.ba0a00bd.svg";